function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "mobile-a",
  d: "M4.787 9.073L1.213 5.499 0 6.711l4.787 4.788L15.073 1.213 13.86 0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#8892C5",
  d: "M17 30.75l897.5.5M17.5 0v80m53-80v80m106-80v80m105-80v80m105-80v80m106-80v80m105-80v80m106-80v80m105-80v80m-685-80v80m105-80v80m106-80v80m105-80v80m106-80v80m105-80v80m105-80v80m106-80v80",
  opacity: 0.4
}), React.createElement("path", {
  stroke: "#8892C5",
  d: "M914.5 0v200"
}), React.createElement("path", {
  stroke: "#FB7D74",
  d: "M58 0v200"
}), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 0,
  y: 106
}, "2019")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 106,
  y: 106
}, "2021")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 209,
  y: 106
}, "2023")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 315,
  y: 106
}, "2025")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 420,
  y: 106
}, "2027")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 526,
  y: 106
}, "2029")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 633,
  y: 106
}, "2031")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 737,
  y: 106
}, "2033")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 843,
  y: 106
}, "2035")), React.createElement("text", {
  fill: "#FB7D74",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 34,
  y: 223
}, "Today")), React.createElement("text", {
  fill: "#8892C5",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 16,
  fontWeight: 400
}, React.createElement("tspan", {
  x: 895,
  y: 223
}, "2036")), React.createElement("use", {
  fill: "#6FDC8B",
  fillRule: "nonzero",
  transform: "translate(23 38)",
  xlinkHref: "#mobile-a"
}), React.createElement("path", {
  fill: "#6FDC8B",
  d: "M21 30h20v3H21z"
}), React.createElement("g", {
  fill: "#FFF"
}, React.createElement("path", {
  d: "M128 30h20v3h-20z"
}), React.createElement("path", {
  d: "M232 30h20v3h-20z"
}), React.createElement("path", {
  d: "M338 30h20v3h-20z"
}), React.createElement("path", {
  d: "M443 30h20v3h-20z"
}), React.createElement("path", {
  d: "M549 30h20v3h-20z"
}), React.createElement("path", {
  d: "M655 30h20v3h-20z"
}), React.createElement("path", {
  d: "M759 30h20v3h-20z"
}), React.createElement("path", {
  d: "M865 30h20v3h-20z"
})), React.createElement("g", {
  fill: "#FFF",
  fontFamily: "Montserrat-Medium, Montserrat",
  fontSize: 14,
  fontWeight: 400
}, React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 107,
  y: 14
}, "87th")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 0,
  y: 14
}, "86th")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 211,
  y: 14
}, "88th")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 316,
  y: 14
}, "89th")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 422,
  y: 14
}, "90th")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 528,
  y: 14
}, "91st")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 633,
  y: 14
}, "92nd")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 738,
  y: 14
}, "93rd")), React.createElement("text", {
  transform: "translate(21 8)"
}, React.createElement("tspan", {
  x: 844,
  y: 14
}, "94th"))));

var SvgS6MobileColors = function SvgS6MobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 934 230"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default "data:image/svg+xml;base64,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";
export { SvgS6MobileColors as ReactComponent };